export default "__VITE_ASSET__BI2qpWI0__"